import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import theme from '../theme';

function PayoutAccountCard({ session }) {
  const navigate = useNavigate();
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [starting, setStarting] = useState(false);
  const [balance, setBalance] = useState(null);

  useEffect(() => { fetchAccount(); }, []);

  const fetchAccount = async () => {
    setLoading(true);
    const { data } = await supabase
      .from('stripe_accounts')
      .select('stripe_account_id, onboarding_status')
      .eq('user_id', session.user.id)
      .maybeSingle();
    setAccount(data);
    setLoading(false);

    if (data?.onboarding_status === 'completato') {
      fetchBalance();
    }
  };

  const fetchBalance = async () => {
    const { data, error } = await supabase.functions.invoke('get-stripe-balance');
    if (!error && data && !data.error) {
      setBalance(data);
    }
  };

  const handleStartOnboarding = async () => {
    setStarting(true);
    const { data, error } = await supabase.functions.invoke('stripe-onboarding', {
      body: { user_id: session.user.id },
    });
    setStarting(false);
    if (error || !data?.url) {
      alert('Errore nella configurazione. Riprova.');
      return;
    }
    window.location.href = data.url;
  };

  if (loading) return <p style={{ color: theme.colors.textMuted, fontSize: theme.font.size.base }}>Caricamento...</p>;

  const isCompleted = account?.onboarding_status === 'completato';
  const isPending = account && !isCompleted;

  if (isCompleted) {
    const available = balance ? (balance.available / 100).toFixed(2) : null;

    return (
      <button
        onClick={() => navigate('/account-stripe')}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: theme.spacing.md,
          padding: theme.spacing.md,
          background: theme.colors.primaryLight,
          border: 'none',
          borderRadius: theme.radius.sm,
          cursor: 'pointer',
          textAlign: 'left',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: theme.spacing.md }}>
          <span style={{ fontSize: 22 }}>✅</span>
          <div>
            <div style={{ fontWeight: 600, color: theme.colors.primary }}>
              {available !== null ? `Saldo: €${available}` : 'Pronto per ricevere pagamenti'}
            </div>
            <div style={{ fontSize: theme.font.size.sm, color: theme.colors.textMuted }}>
              Tocca per gestire il tuo account
            </div>
          </div>
        </div>
        <span style={{ fontSize: 18, color: theme.colors.primary }}>›</span>
      </button>
    );
  }

  if (isPending) {
    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: theme.spacing.md, padding: theme.spacing.md, background: theme.colors.warningBgSoft, borderRadius: theme.radius.sm, marginBottom: theme.spacing.md }}>
          <span style={{ fontSize: 22 }}>⏳</span>
          <div>
            <div style={{ fontWeight: 600, color: theme.colors.warningText }}>Configurazione in corso</div>
            <div style={{ fontSize: theme.font.size.sm, color: theme.colors.textMuted }}>Completa i dati richiesti per poter ricevere pagamenti</div>
          </div>
        </div>
        <button onClick={handleStartOnboarding} disabled={starting}
          style={{ width: '100%', background: theme.colors.primary, color: theme.colors.white, border: 'none', borderRadius: theme.radius.sm, padding: 12, fontSize: theme.font.size.md, fontWeight: 700, cursor: 'pointer' }}>
          {starting ? 'Attendere...' : '↻ Riprendi configurazione'}
        </button>
      </div>
    );
  }

  return (
    <div>
      <p style={{ color: theme.colors.textMuted, fontSize: theme.font.size.base, marginBottom: theme.spacing.md }}>
        Per candidarti a un lavoro e ricevere pagamenti, devi prima configurare il tuo account per i pagamenti in uscita. Ci vogliono pochi minuti.
      </p>
      <button onClick={handleStartOnboarding} disabled={starting}
        style={{ width: '100%', background: theme.colors.primary, color: theme.colors.white, border: 'none', borderRadius: theme.radius.sm, padding: 12, fontSize: theme.font.size.md, fontWeight: 700, cursor: 'pointer' }}>
        {starting ? 'Attendere...' : '💼 Configura per ricevere pagamenti'}
      </button>
    </div>
  );
}

export default PayoutAccountCard;